import { toJcamps } from './toJcamps';
/**
 * @param analysis
 * @param options
 */
export function toJcamp(analysis, options = {}) {
    return toJcamps(analysis, options).join('\n');
}
//# sourceMappingURL=toJcamp.js.map